"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Logo = _interopRequireDefault(require("../../Navbar/components/Logo"));
var _constants = require("../../constants");
var _Link = _interopRequireDefault(require("../../Link/Link"));
var _CurrencyDropdown = _interopRequireDefault(require("../../CurrencyDropdown/CurrencyDropdown"));
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
var _Svg = _interopRequireDefault(require("../../Svg/Svg"));
var _MediaContext = require("../../MediaContext/MediaContext");
var _ContactButton = _interopRequireDefault(require("../../ContactUs/ContactButton"));
var _envConstants = require("../../../env-constants");
var FooterContent = function FooterContent(_ref) {
  var logo = _ref.logo,
    text = _ref.text,
    navigationLinks = _ref.navigationLinks,
    currencyHidden = _ref.currencyHidden,
    partners = _ref.partners,
    socialLinks = _ref.socialLinks,
    brands = _ref.brands,
    supportedCurrencies = _ref.supportedCurrencies;
  return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "footer--content"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "padding-right-xl"
  }, /*#__PURE__*/_react["default"].createElement(_Logo["default"], {
    config: logo,
    iconClassName: "icon--xxl"
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm padding-bottom-lg"
  }, text), /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-bottom-lg flex"
  }, socialLinks.map(function (link) {
    return /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      href: link.href,
      external: link.externalLink,
      className: "col",
      key: JSON.stringify(link)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col"
    }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      className: "icon--md",
      name: link.icon,
      fill: _constants.COLORS.BLACK
    })));
  })), _envConstants.ENV.SITE === 'qd' && /*#__PURE__*/_react["default"].createElement(_ContactButton["default"], {
    hideIcon: true,
    text: "Contact",
    template: "OutlineContactButton",
    brand: _envConstants.ENV.SITE
  }), !currencyHidden && /*#__PURE__*/_react["default"].createElement(_CurrencyDropdown["default"], {
    buttonType: _constants.BUTTON_TYPES.GHOST,
    supportedCurrencies: supportedCurrencies
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "navigation-links margin-top-sm"
  }, navigationLinks.map(function (category) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: JSON.stringify(category),
      className: "nav--section height-100% "
    }, /*#__PURE__*/_react["default"].createElement("h2", {
      className: "text-md d8-u-text-uppercase d8-u-ls-sm margin-bottom-sm"
    }, category.title), /*#__PURE__*/_react["default"].createElement("ul", null, category.links.map(function (link) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        style: {
          marginTop: '0.5rem'
        },
        key: "".concat(JSON.stringify(link), "-mobile")
      }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
        className: (0, _classnames["default"])('margin-top-md', 'text-sm', 'd8-u-color-contrast-high', link.strong && 'd8-u-text-bold'),
        href: link.href,
        external: link.externalLink
      }, link.label));
    })));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "partners-links margin-y-lg"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "nav--section height-100%"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid gap-md"
  }, brands && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6@md"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-md d8-u-text-uppercase d8-u-ls-sm margin-bottom-sm"
  }, "OUR BRANDS"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-wrap footer-logos margin-y-lg"
  }, brands.map(function (brand) {
    return /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      key: brand.iconName,
      className: "inline-block margin-right-sm flex col",
      href: brand.href,
      external: brand.externalLink
    }, /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
      greaterThanOrEqual: _constants.BREAKPOINTS.MD
    }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      className: 'icon--xxl',
      name: brand.iconName,
      fill: _constants.COLORS.BLACK
    })), /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
      lessThan: _constants.BREAKPOINTS.MD
    }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      className: 'icon--xl',
      name: brand.iconName,
      fill: _constants.COLORS.BLACK
    })));
  }))), partners && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6@md"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-md d8-u-text-uppercase d8-u-ls-sm margin-bottom-sm"
  }, "OUR PARTNERS"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-wrap footer-logos margin-y-lg"
  }, partners.map(function (partner) {
    return /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      key: partner.iconName,
      className: "inline-block margin-right-sm flex col",
      href: partner.href,
      external: partner.externalLink
    }, /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
      greaterThanOrEqual: _constants.BREAKPOINTS.MD
    }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      className: 'icon--xxl',
      name: partner.iconName,
      fill: _constants.COLORS.BLACK
    })), /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
      lessThan: _constants.BREAKPOINTS.MD
    }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      className: 'icon--xl',
      name: partner.iconName,
      fill: _constants.COLORS.BLACK
    })));
  })))))));
};
FooterContent.propTypes = {
  logo: _propTypes["default"].object,
  text: _propTypes["default"].string,
  navigationLinks: _propTypes["default"].arrayOf(_propTypes["default"].object),
  currencyHidden: _propTypes["default"].bool,
  partners: _propTypes["default"].array,
  brands: _propTypes["default"].array,
  supportedCurrencies: _propTypes["default"].array,
  socialLinks: _propTypes["default"].arrayOf(_propTypes["default"].object)
};
var _default = exports["default"] = FooterContent;